var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
var TabsContainer = styled.div.withConfig({ displayName: "TabsContainer", componentId: "sc-2wzsuf" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  background: #e3f2fc;\n  border-radius: 8px;\n"], ["\n  display: flex;\n  background: #e3f2fc;\n  border-radius: 8px;\n"])));
var Tab = styled.span.attrs(function (_a) {
    var selected = _a.selected;
    return ({
        role: 'tab',
        'aria-selected': selected ? 'true' : undefined,
    });
}).withConfig({ displayName: "Tab", componentId: "sc-1wm4d2a" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 8px 12px;\n  cursor: pointer;\n  ", "\n"], ["\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 8px 12px;\n  cursor: pointer;\n  ", "\n"])), function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected
        ? "\n          color: " + theme.colors.white + ";\n          background: " + theme.colors.primary + ";\n          border-radius: 8px;\n          "
        : "\n        color: " + theme.colors.primary + ";\n      ";
});
var PeriodControl = function (_a) {
    var onDateChanged = _a.onDateChanged, _b = _a.date, date = _b === void 0 ? 'weekly' : _b, rest = __rest(_a, ["onDateChanged", "date"]);
    return (_jsxs(TabsContainer, __assign({}, rest, { role: 'tablist' }, { children: [_jsx(Tab, __assign({ selected: date === 'daily', onClick: function () { return onDateChanged('daily'); } }, { children: "Daily" }), void 0), _jsx(Tab, __assign({ selected: date === 'weekly', onClick: function () { return onDateChanged('weekly'); } }, { children: "Weekly" }), void 0), _jsx(Tab, __assign({ selected: date === 'monthly', onClick: function () { return onDateChanged('monthly'); } }, { children: "Monthly" }), void 0), _jsx(Tab, __assign({ selected: date === 'yearly', onClick: function () { return onDateChanged('yearly'); } }, { children: "Yearly" }), void 0)] }), void 0));
};
export { PeriodControl };
var templateObject_1, templateObject_2;
